/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle,  Grid,  LinearProgress,  Paper, Snackbar, SnackbarCloseReason, TextField} from '@mui/material';
import { useState } from 'react';
import { AutoCompleteProdutorListagem } from '../../../shared/forms';
import { LCDPRService } from '../../../shared/services/api/fiscal/LCDPR/LCDPRService';
import RelatorioArquivoLCDPR from './RelatorioArquivoLCDPR';
           
export const GeraArquivoLCDPR: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false); 
  const [uidProdutor, setUidProdutor] = useState(0);   
  const [openmsg, setOpenmsg] = useState(false);
  const anoAtual: number = new Date().getFullYear();
  const [ano, setAno] = useState(anoAtual);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
    
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,     
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {       
      return;
    }           
    setOpenmsg(false);          
  };  
  
  const handleProdutor = (uidprodutor: number | undefined) => {    
    if (uidprodutor != null) {     
      setUidProdutor(uidprodutor);                  
    }else{                       
      setUidProdutor(0);                         
    }                 
  };     
  const handleGeraArquivo = () => {                                 
    LCDPRService                                                  
      .GeraArquivo(true, uidProdutor, ano)        
      .then((result) => {                                              
        setIsLoading(false);                                            
        if (result instanceof Error) {                                                         
          setTms('error');                              
          setMsg(result.message);                                   
          setOpenmsg(true);                                          
        }else {       
          const produtor = `0000|LCDPR|0013|${result.produtor.cpf}|${result.produtor.nome}|0|0||0101${ano}|3112${ano}\r\n0010|1\r\n0030|${result.produtor.endereco}|${result.produtor.numero}|${result.produtor.complemento || ''}|${result.produtor.bairro}|${result.produtor.uf}|${result.produtor.idmunicipio}|${result.produtor.cep}|${result.produtor.numtel || ''}|${result.produtor.email}`;
          const fazenda = result.fazendas.map((row) => {
            const terceiros = row.terceiros.map((row1) => {
              return `0045|${row1.idir}|${row1.tipocontraparte}|${row1.cpf}|${row1.nome}|${row1.percentual}`;
            }).join('\r\n');
            return `0040|${row.idir}|BR|BRL|${row.caditr}|${row.caepf || ''}|${row.ie}|${row.descricao}|${row.endereco}|${row.numero}|${row.compl || ''}|${row.bairro}|${row.uf}|${row.idmunicipio}|${row.cep}|${row.tipocontraparte}|${row.percentual}\r\n${terceiros}`;
          }).join('\r\n');

          const contabancaria = result.contas.map((row) => {
            return `0050|${row.idconta}|BR|${row.banco}|${row.nomebanco}|${row.agencia}|${row.numeroconta}`;
          }).join('\r\n');

          const lancamentos = result.lancamentos.map((row) => {
            return `Q100|${row.datacaixa}|${row.idir}|${row.idconta}|${row.numero}|${row.tipodoc}|${row.historico}|${row.participante}|${row.tipolan}|${row.entrada}|${row.saida}|${row.saldo}|${row.letra}`;
          }).join('\r\n');

          const resuno = result.resumo.map((row) => {
            return `Q200|${row.mes}${row.ano}|${row.entrada}|${row.saida}|${row.saldo}|${row.letra}`;
          }).join('\r\n');   
          const contentArray = [                   
            produtor,                                               
            fazenda,                                                                                          
            contabancaria,                                                                                                                    
            lancamentos,                                                                                                        
            resuno                                          
          ];               
          const content = contentArray.join('\r\n');
          const totalLinhas = content.split('\r\n').length;
          const contentFinal = `${content}\r\n9999||||||${totalLinhas+1}`;
          const blob = new Blob([contentFinal], { type: 'text/plain;charset=utf-8' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'lcdpr.txt';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);              
        }                             
      });                                                  
  };                  
                          
  const handleImprimir = () => {                                                                  
    LCDPRService                                                                                    
      .GeraArquivo(false, uidProdutor, ano)                                    
      .then((result) => {                           
        setIsLoading(false);                                       
        if (result instanceof Error) {                                      
          setTms('error');                                     
          setMsg(result.message);                           
          setOpenmsg(true);                                
        }else {             
          RelatorioArquivoLCDPR(result, ano.toString());         
        }                
      });                                 
  };        
  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}      
        </Alert>
      </Snackbar>
      <Box gap={1} display="flex" alignItems="center" alignSelf='center' flexDirection="row"  margin={1} alignContent='center'>
        <Box  width='auto' alignItems="center" component={Paper} height="auto" margin={1}
          alignContent='center'>
          <DialogTitle>Gera Aarquivo LCDPR</DialogTitle>
          <DialogContent  dividers>   
            <Box gap={1} display="flex" alignItems="center" alignSelf='center' flexDirection="row"  margin={1} alignContent='center'>
              {isLoading && (           
                <Grid item>  
                  <LinearProgress variant='indeterminate' />  
                </Grid>                           
              )}  
              <Grid item>  
                <AutoCompleteProdutorListagem
                  uuidprodutor={handleProdutor}        
                />   
              </Grid>   
              <Grid item> 
                <TextField
                  type='number'
                  sx={{ width: '10ch' }}
                  size='small'
                  value={ano}
                  onChange={e => setAno(Number(e.target.value))}
                />    
              </Grid>   
            </Box>
          </DialogContent>     
          <DialogActions>
            <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleImprimir}>Imprimir</Button>
            <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleGeraArquivo}>Gera Arquivo</Button>
          </DialogActions>
        </Box>
      </Box>
    </Box>
  );
};   